import Vue from 'vue'
import VueResize from 'vue-resize'

Vue.use(VueResize)
